module.exports = {"411681001":"花园","411681002":"水寨","411681003":"东方","411681004":"莲花","411681005":"千佛阁","411681006":"光武","411681100":"南顿镇","411681101":"孙店镇","411681102":"李寨镇","411681103":"贾岭镇","411681104":"高寺镇","411681105":"新桥镇","411681106":"付集镇","411681107":"官会镇","411681108":"丁集镇","411681109":"郑郭镇","411681110":"秣陵镇","411681111":"王明口镇","411681112":"范集镇","411681113":"三店镇","411681114":"永丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411681.json
// module id = 1685
// module chunks = 0